module.exports = __webpack_public_path__ + "img/React.dd2eabb7.png";